// extracted by mini-css-extract-plugin
export default {"stat":"nAErSRulsYj8sp2MvZxC","stats":"nUTbsLhpPCr9qvQ8qXjw","statsWrapper":"fXfhu07IJ9s9HbjzyMJI"};